<template>
  <div class="cp-results-container">
    <div class="cp-results-header">
      <h2>集采成果展示</h2>
      <p class="subtitle">集中采购管理成果应用表汇总，面向集团全员公开展示</p>
    </div>

    <!-- 筛选区域 -->
    <div class="filter-section">
      <el-form :model="searchForm" inline label-width="80px" label-suffix="：">
        <el-form-item label="年度">
          <el-input
            v-model="searchForm.resultYear"
            placeholder="请输入年度"
            clearable
            style="width: 140px"
          />
        </el-form-item>
        <el-form-item label="品类名称">
          <el-input
            v-model="searchForm.categoryName"
            placeholder="请输入品类名称"
            clearable
            style="width: 180px"
          />
        </el-form-item>
        <el-form-item label="物资编码">
          <el-input
            v-model="searchForm.materialCode"
            placeholder="请输入物资编码"
            clearable
            style="width: 180px"
          />
        </el-form-item>
        <el-form-item label="物资名称">
          <el-input
            v-model="searchForm.materialName"
            placeholder="请输入物资名称"
            clearable
            style="width: 180px"
          />
        </el-form-item>
        <el-form-item label="集团名称">
          <el-input
            v-model="searchForm.groupName"
            placeholder="请输入集团名称"
            clearable
            style="width: 180px"
          />
        </el-form-item>
        <el-form-item label="源头厂家">
          <el-input
            v-model="searchForm.sourceSupplierName"
            placeholder="请输入源头厂家"
            clearable
            style="width: 180px"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="small" @click="handleSearch">查询</el-button>
          <el-button size="small" @click="handleReset">重置</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!-- 卡片列表 -->
    <div v-loading="loading" class="results-list">
      <div v-if="list.length === 0 && !loading" class="empty-state">
        <i class="el-icon-document" style="font-size:48px;color:#c0c4cc"></i>
        <p style="color:#909399;margin-top:10px">暂无集采成果数据</p>
      </div>

      <el-card v-for="item in list" :key="item.id" class="result-card" shadow="hover">
        <div slot="header" class="card-header">
          <span class="card-title">{{ item.applyName || '成果应用表' }}</span>
          <el-tag type="success" size="small">已发布</el-tag>
        </div>
        <div class="card-content">
          <div class="apply-info">
            <span class="info-label">应用表编号：</span>
            <span>{{ item.applyCode }}</span>
          </div>
          <div class="data-table-wrapper" v-if="getExcelData(item).length > 0">
            <el-table :data="getPageData(item)" border size="mini" style="margin-top: 10px">
              <el-table-column
                v-for="col in getExcelColumns(item)"
                :key="col"
                :prop="col"
                :label="col"
                min-width="120"
                show-overflow-tooltip
              />
            </el-table>
          </div>
        </div>
        <div class="card-footer">
          <span>创建时间: {{ item.createTime }}</span>
          <span>创建人: {{ item.createName || '采购交易中心' }}</span>
        </div>
      </el-card>

      <div class="pagination-wrapper" v-if="total > 0">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="searchForm.pageNo"
          :page-sizes="[10, 20, 50]"
          :page-size="searchForm.pageSize"
          layout="total, sizes, prev, pager, next"
          :total="total"
        />
      </div>
    </div>
  </div>
</template>

<script>
import request from "@/config/utils/request";

export default {
  name: "CpResults",
  data() {
    return {
      list: [],
      total: 0,
      loading: false,
      searchForm: {
        materialCode: "",
        materialName: "",
        resultYear: "",
        categoryName: "",
        groupName: "",
        sourceSupplierName: "",
        pageNo: 1,
        pageSize: 10
      }
    };
  },
  created() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      this.loading = true;
      request({
        url: "/apis/pp/centralProc/queryCpResultDisplay",
        method: "post",
        data: this.searchForm
      }).then(res => {
        if (res.data.code === "0") {
          const data = res.data.data || {};
          this.list = data.rows || data.list || [];
          this.total = data.recordsTotal || data.total || 0;
        }
      }).catch(() => {
        this.$message({ message: "请求失败，请稍后重试", type: "error", duration: 3000, showClose: true, ccuiCustom: true });
      }).finally(() => {
        this.loading = false;
      });
    },
    handleSearch() {
      this.searchForm.pageNo = 1;
      this.fetchData();
    },
    handleReset() {
      this.searchForm = {
        materialCode: "",
        materialName: "",
        resultYear: "",
        categoryName: "",
        groupName: "",
        sourceSupplierName: "",
        pageNo: 1,
        pageSize: 10
      };
      this.fetchData();
    },
    handleSizeChange(size) {
      this.searchForm.pageSize = size;
      this.fetchData();
    },
    handleCurrentChange(page) {
      this.searchForm.pageNo = page;
      this.fetchData();
    },
    getExcelData(item) {
      try {
        return JSON.parse(item.excelData || "[]");
      } catch (e) {
        return [];
      }
    },
    getExcelColumns(item) {
      const data = this.getExcelData(item);
      return data.length > 0 ? Object.keys(data[0]) : [];
    },
    getPageData(item) {
      const data = this.getExcelData(item);
      return data.slice(0, 20); // 只展示前20条预览
    }
  }
};
</script>

<style scoped>
.cp-results-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
}
.cp-results-header {
  text-align: center;
  padding: 40px 0 30px;
}
.cp-results-header h2 {
  font-size: 24px;
  color: #303133;
  margin: 0;
}
.subtitle {
  color: #909399;
  font-size: 14px;
  margin-top: 8px;
}
.filter-section {
  background: #f5f7fa;
  padding: 15px;
  border-radius: 4px;
  margin-bottom: 20px;
}
.result-card {
  margin-bottom: 20px;
}
.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.card-title {
  font-size: 16px;
  font-weight: bold;
  color: #303133;
}
.card-content {
  padding: 10px 0;
  line-height: 1.8;
  color: #606266;
}
.apply-info {
  margin-bottom: 10px;
}
.info-label {
  color: #909399;
}
.data-table-wrapper {
  overflow-x: auto;
}
.card-footer {
  display: flex;
  justify-content: space-between;
  color: #909399;
  font-size: 12px;
  margin-top: 10px;
  padding-top: 10px;
  border-top: 1px solid #ebeef5;
}
.empty-state {
  text-align: center;
  padding: 80px 0;
}
.pagination-wrapper {
  text-align: center;
  margin-top: 20px;
}
</style>
